import React from 'react';
import styles from './boardList.mod.scss';
import BoardGrid from './boardGrid';

function BoardList({ onBoardItemClick }) {
  return (
    <BoardGrid
      onBoardItemClick={onBoardItemClick}
    />
  );
}

export default BoardList;
